import styled from 'styled-components'

import FilterChip from 'LuxKit/Chips/FilterChip'

/**
 * Pill trigger for the offer page's date/occupancy filter dropdowns — the chip
 * treatment the mobile offer page filter row uses (see the *MobileStickyHeaderFilters
 * components), as opposed to the labelled box of `OfferFilterDropdownBox`.
 *
 * It fills its container so a row of chips can split the available width evenly, and
 * truncates its label instead of widening the row, which the narrow surfaces these
 * chips live on (mobile, the chat trip planner drawer) depend on.
 */
const OfferFilterSelectChip = styled(FilterChip)`
  width: 100%;
  min-width: 0;
  justify-content: center;

  /*
   * FilterChip renders its label twice — a hidden copy that reserves the bold width and
   * the visible copy layered on top — so both have to be shrinkable for the label to
   * ellipsise rather than overflow the chip.
   */
  > *:not(svg) {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;

    > * {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`

export default OfferFilterSelectChip
